module.exports = __webpack_public_path__ + "images/program/schoolHat.97ab517f.svg";